// extracted by mini-css-extract-plugin
export default {"select":"RateBtn_select__9pVtE"};